module.exports = __webpack_public_path__ + "static/img/se.c4c4ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/se.png
// module id = E8C7
// module chunks = 18